import { HttpServiceBase } from "../../../common-services/Http/HttpServiceBase";
import { Result } from "../../../common-models/Result";
import { GetUpdatedErpOrderInput } from "./GetUpdatedErpOrderInput";
import { GetUpdatedErpOrderOutput } from "./GetUpdatedErpOrderOutput";

export class GetUpdatedErpOrderService extends HttpServiceBase {

  handle = (input: GetUpdatedErpOrderInput): Promise<Result<GetUpdatedErpOrderOutput> | null> => {
    const parameters = input ? this.objectToUrl(input) : '';
    const promise = this.http.get<Result<GetUpdatedErpOrderOutput>>(`${this.baseUrlSislogApi}/v2/order/${input.orderId}/updated-erp-order${parameters}`);
    return promise;
  }
}